/*eslint-disable*/ 

export default article_container => {
let $article_container = $(article_container)
let first_load = true

  $article_container.find('.products-container').each((i, product_container)=>{
    $(product_container).find('.explore').click(()=>{
      $(product_container).hasClass('open')
        ? $(product_container).removeClass('open')
        : $(product_container).addClass('open')
    })
  })

  $(window).on('scroll load', ()=>{
    $article_container.find('.products-container').each((i, product_container)=>{
      //check number of products in product_container
      let products = $(product_container).find( ".collection__product_card" ).length

      //Set first product container to open automatically if it has products
      if(products > 0 && window.matchMedia("(min-width: 768px)").matches) {
        let product_container_position = $(product_container).offset().top
        if(window.pageYOffset + 700 >= product_container_position && first_load){
          $(product_container).addClass('open')
          first_load = !first_load
        }
      }
    })
  })
}





// WEBPACK FOOTER //
// ./src/scripts/components/article-products.js